import React, { memo } from 'react';
var RenderErrors = function RenderErrors(_ref) {
  var showErrors = _ref.showErrors,
    error = _ref.error;
  return showErrors && /*#__PURE__*/React.createElement("div", {
    className: "help-block"
  }, error);
};
export default /*#__PURE__*/memo(RenderErrors);